module.exports = __webpack_public_path__ + "media/images/promotion/2-2430beb2b1efb0df4bda1f2dbf6b236f.png";